import React from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'


export const PublicRoute = ({ children, isAuthenticated }) => {

  const lastPage = localStorage.getItem(`lastPage`) ?? '/CC-RI/RX-GN'

    return isAuthenticated ? <Navigate to={lastPage} /> : children
}